module.exports = __webpack_public_path__ + "static/media/daily-mail.dd84d7f5.png";